import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_GUESTS, res.data)
  })
)

export const getGuest = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_GUEST, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveGuest(obj).then(res => {
    commit(types.SET_GUEST, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const importUsers = async ({ commit }, obj) => {
  await services.importUsers(obj).then(res => {
    return res
  })
}

export const deleteGuest = async ({ commit }, id) => {
  await services.delGuest(id).then(res => {
    return res
  })
}
